__turbopack_context__.v({
  "dropdownMenuItem": "Menu-module-scss-module__jKyuia__dropdownMenuItem",
  "groupList": "Menu-module-scss-module__jKyuia__groupList",
  "groupListItemLabel": "Menu-module-scss-module__jKyuia__groupListItemLabel",
  "menuItemLink": "Menu-module-scss-module__jKyuia__menuItemLink",
  "menuItemWrapper": "Menu-module-scss-module__jKyuia__menuItemWrapper",
  "menuWrapper": "Menu-module-scss-module__jKyuia__menuWrapper",
  "moreMenuItemsDropdownContainer": "Menu-module-scss-module__jKyuia__moreMenuItemsDropdownContainer",
  "primaryToolbarButton": "Menu-module-scss-module__jKyuia__primaryToolbarButton",
  "subGroupWrapper": "Menu-module-scss-module__jKyuia__subGroupWrapper",
  "subNavWrapper": "Menu-module-scss-module__jKyuia__subNavWrapper",
  "visible": "Menu-module-scss-module__jKyuia__visible",
});
